module.exports = __webpack_public_path__ + "img/cap_07.94cbeb5d.jpg";